import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics';

export const SET_TEST_SEARCH_VALUE = `${NAMESPACE}/SET_TEST_SEARCH_VALUE`;
export const ADD_TO_SELECTED_TESTS = `${NAMESPACE}/ADD_TO_SELECTED_TESTS`;
export const REMOVE_FROM_SELECTED_TESTS = `${NAMESPACE}/REMOVE_FROM_SELECTED_TESTS`;
export const CLEAR_SELECTED_TESTS = `${NAMESPACE}/CLEAR_SELECTED_TESTS`;
export const ALL_TESTS_LOADED = `${NAMESPACE}/TEST_LOADING_COMPLETE`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_ORGANIZATION = createApiNamespacedConstants('GET_ORGANIZATION');
export const GET_TEST_NAMES = createApiNamespacedConstants('GET_TEST_NAMES');
export const GET_TEST_METRICS = createApiNamespacedConstants('GET_TEST_METRICS');
export const GET_PREVIOUS_TEST_METRICS = createApiNamespacedConstants('GET_PREVIOUS_TEST_METRICS');
export const GET_TESTS = createApiNamespacedConstants('GET_TESTS');
export const GET_ALL_TESTS = createApiNamespacedConstants('GET_ALL_TESTS');

// errors
export const ERROR_FAILED_GET_TESTS = 'failed to load tests';
export const ERROR_FAILED_LOAD_METRICS = 'failed to load test metrics';
export const ERROR_FAILED_LOAD_ORGANIZATION = 'failed to load organization';
